import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnotifyService } from 'ng-snotify';
import { ValidatorService } from 'app/shared/services/validator.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { EmployeeService } from 'app/views/appviews/employee.service';
import { IDtoEmployeeShippingAddress } from 'app/shared/models/employee/dto-employee-shipping-address.model';
import { RecruitmentService } from '../../recruitment.service';
import { ISelect } from 'app/shared/models/select.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { MatRadioChange } from '@angular/material';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { MessageService } from 'app/views/appviews/message.service';
import { IDtoMessageDetail } from 'app/shared/models/dto-message-detail.model';
import { ListBudgetsComponent } from 'app/views/appviews/quote/budgets/list-budgets.component';
@Component({
  selector: 'app-enter-address',
  templateUrl: 'enter-address.template.html'
})
export class EnterAddressComponent implements OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private errorMessages: any;
  private param: string;
  /**Formulario */
  private frmAddress: FormGroup;
  private catalogTowns: ISelect[];
  private catalogStates: ISelect[];
  private address: IDtoEmployeeShippingAddress;
  private useAddress = true;
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];
  private decimalCounter = 0;
  @ViewChild('confirmSwal', { static: false }) private confirmSwal: SwalComponent;
  constructor(private formBuilder: FormBuilder
    , private recruitmentService: RecruitmentService
    , private employeeService: EmployeeService
    , private configGeneral: AppConfig
    , public snotifyService: SnotifyService
    , private router: Router
    , private spinner: NgxSpinnerService
    , private route: ActivatedRoute
    , private configurationService: ConfigurationService
    , private messageService: MessageService) {
      if (this.configurationService.isReady) {
        this.getCatalogStates();
        //this.getEmployeeShippingAddress();
    } else {
        this.configurationService.settingsLoaded$.subscribe(x => {
          this.getCatalogStates();
          //this.getEmployeeShippingAddress();
        });
    }
    this.frmAddress = formBuilder.group({
      street: [null, [Validators.required, Validators.maxLength(100)]],
      interiorNumber: [null, [Validators.maxLength(10)]],
      externalNumber: [null, [Validators.required, Validators.maxLength(10)]],
      suburb: [null, [Validators.required, Validators.maxLength(50)]],
      townId: [null, [Validators.required]],
      stateId: [null, [Validators.required]],
      postalCode: [null, [Validators.required, Validators.maxLength(6), Validators.minLength(5)]],
      reference: [null, [Validators.maxLength(300)]],
      useAddress: [null, [Validators.required]],
      personalNumber: [null, [Validators.maxLength(10), Validators.minLength(10)]]
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['case']) {
        this.param = params['case'];
      }
    });
  }
  private onSubmit() {
    if (this.frmAddress.valid) {
      let dto = this.frmAddress.value as IDtoEmployeeShippingAddress;
      dto.jobCandidateId = this.address.jobCandidateId;
      this.updateEmployeeShippingAddress(dto);
    }
  }
  private getCatalogStates(): void {
    this.recruitmentService.getCatalogStates().subscribe((res) => {
      this.catalogStates = res;
    });
  }
  private getCatalogTowns(id: string): void {
    this.recruitmentService.getCatalogTowns(id).subscribe((res) => {
      this.frmAddress.get('townId').setValue(null);
      this.catalogTowns = res;
    });
  }
  private change(event): void {
    let personalNumber = this.frmAddress.controls['personalNumber'].value
    if (
      this.navigationKeys.indexOf(event.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      (event.key === 'a' && event.ctrlKey === true) || // Allow: Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) || // Allow: Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) || // Allow: Ctrl+V
      (event.key === 'x' && event.ctrlKey === true) || // Allow: Ctrl+X
      (event.key === 'a' && event.metaKey === true) || // Allow: Cmd+A (Mac)
      (event.key === 'c' && event.metaKey === true) || // Allow: Cmd+C (Mac)
      (event.key === 'v' && event.metaKey === true) || // Allow: Cmd+V (Mac)
      (event.key === 'x' && event.metaKey === true) || // Allow: Cmd+X (Mac)
      (event.key === '.' && this.decimalCounter < 1) // Allow: only one decimal point
    ) return;
    if (personalNumber.length == 10) {
      this.spinner.show();
      this.getEmployeeShippingAddress(personalNumber);
    }
  }
  
  private getEmployeeShippingAddress(personalNumber: string): void {
    this.employeeService.getEmployeeShippingAddress(personalNumber).subscribe((res) => {
      if (res == null) {
        this.configGeneral.newToast('Error', 'No existe  un empleado con el número de telefono proporcionado', 'error');
      }
      this.address = res;
      this.spinner.hide();
    });
  }
  private updateEmployeeShippingAddress(dto: IDtoEmployeeShippingAddress): void {
    this.spinner.show();
    this.employeeService.updateEmployeeShippingAddress(dto)
      .subscribe(
        (x) => {
          if(this.configGeneral.notificationSuccessError(x)) {
            let params = this.param.split('|');
            let c = params[1];
            let id = params[0];
            let dto = {} as IDtoMessageDetail;
            dto.recipient = id;
            dto.case = c;
            let message = this.useAddress == true ? 'USAR ACTUAL' : 'PROPORCIONAR OTRA';
            switch (c) {
              case '1':
                dto.messageSent = `DIRECCION / ${message}`;
                break;
              case '2':
                dto.messageSent = `TAJERTAS / ${message}`;
                break;
              case '3':
                dto.messageSent = `NUEVO INGRESO / ${message}`;
                break;
            }
            this.addMessageDetail(dto);
          }
          // if (!this.configGeneral.notificationSuccessError(x)) {
          //   this.frmAddress.get('useAddress').setValue(null)
          // } else {
          //   this.address = x.data as IDtoEmployeeShippingAddress;
          // }
          this.frmAddress.get('personalNumber').setValue(null)
          this.address = null;
          this.frmAddress.get('useAddress').setValue(null)
          this.spinner.hide()
        },
        (errMessage) => {
          this.frmAddress.get('useAddress').setValue(null)
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      });
  }
  private addMessageDetail(dto: IDtoMessageDetail): void {
    this.spinner.show();
    this.messageService.addMessageDetail(dto)
      .subscribe(
        (x) => {
        },
        (errMessage) => {
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      });
  }
  private radioChange($event: MatRadioChange) {
    this.useAddress = $event.value;
    if (this.useAddress) {
      this.confirmSwal.title = 'Se usará su dirección actual como dirección de envío. ¿Seguro que desea continuar?';
      this.confirmSwal.show().then((result) => {
        if (result.value) {
          this.spinner.show();
          this.updateEmployeeShippingAddress(this.address);
        } else {
          this.frmAddress.get('useAddress').setValue(null)
        }
      });
    }
  }
}
